<script setup lang="ts">
import { ref } from "vue";
const { isMobile, isTablet, isDesktop } = useDevice();
import { ChevronDownIcon } from "@heroicons/vue/24/outline";

const props = defineProps<{
  title: string;
  content: string | undefined;
  open?: boolean;
}>();

const isOpen = ref(props.open);

const toggleDropdown = () => {
  // if (isMobile) {
  isOpen.value = !isOpen.value;
  // }
};

// state dropdown
</script>
<template>
  <div class="mt-4 border-t-[0.5px] pt-4 md:ml-6 md:mt-0 md:border-none">
    <div class="flex justify-between" @click="toggleDropdown">
      <h3 class="font-semibold text-gray-600">{{ props.title }}</h3>
      <ChevronDownIcon
        :class="{ 'rotate-180': isOpen }"
        class="heroicon-sw-1.5 h-3 w-3 md:hidden"
      />
    </div>
    <div
      v-html="props.content"
      v-show="isOpen"
      class="prose pt-2 text-gray-600"
    ></div>
  </div>
</template>
